<script setup lang="ts">
import { ref } from 'vue';
import InputNumber from 'primevue/inputnumber';

interface Props {
  number: any;
  title: string;
  permission?: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ changeNumber: [value: any] }>();

const editNumberField = ref({
  isEdit: false,
  data: props.number
});

const handleSave = () => {
  emits('changeNumber', editNumberField.value.data);
  editNumberField.value.isEdit = false;
};
</script>
<template>
  <div class="number-worksheet-editor font-bold mt-2 mb-2">
    <div class="flex" v-if="!editNumberField.isEdit">
      <span class="text-center mr-4" v-if="permission">
        <i class="pi pi-pencil cursor-pointer" @click="editNumberField = { isEdit: true, data: number }"></i>
      </span>
      <div class="min-w-label">{{ title }}:</div>
      <div class="font-normal w-6rem">{{ number || 0 }}</div>
    </div>
    <div class="flex" v-else>
      <div class="min-w-label">{{ title }}:</div>
      <div class="w-3rem">
        <InputNumber v-model="editNumberField.data" :min="0" />
      </div>
      <div class="text-center ml-2 flex gap-2 align-items-center">
        <i class="pi pi-check cursor-pointer" @click="handleSave()"></i>
        <i class="pi pi-times cursor-pointer" @click="editNumberField = { isEdit: false, data: number }"></i>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
:deep(.p-inputnumber .p-inputnumber-input) {
  width: 100%;
}
</style>
